export const useEditorHooks = () => {
  const isEditorEmpty = (editorContent: string) => {
    return editorContent === "<p><br></p>" || editorContent === "<p></p>" || editorContent === "<p> </p>";
  };

  return { isEditorEmpty };
};
